import { createApiRef, DiscoveryApi } from "@backstage/core-plugin-api";
import { ApfApi, Backup, Deployment, GetBackupsOptions } from "./types";

export const apfApiRef = createApiRef<ApfApi>({
  id: 'plugin.apf.api'
})

export class ApfClient implements ApfApi {
  private readonly discovery: DiscoveryApi;

  constructor(discovery: DiscoveryApi) {
    this.discovery = discovery;
  }

  async generateConfig(deployment: string, namespace?: string, snapshot?: string): Promise<string> {
    const url =`${await this.getBackendBaseUrl()}/generate`
    const params = new URLSearchParams()
    params.set('deployment', deployment)
    if( namespace !== undefined ) {
      params.set('namespace', namespace)
    }
    if(snapshot !== undefined) {
      params.set('snapshot', snapshot)
    }
    const response = await fetch( `${url}?${params.toString()}`)
    this.throwOnError(response)
    return response.text()
  }

  async getDeployments(): Promise<Deployment[]> {
    const url =`${await this.getBackendBaseUrl()}/deployments`
    const response = await fetch(url)
    this.throwOnError(response)
    return response.json()
  }

  async getBackups(deployment: string, {namespace, cluster}: GetBackupsOptions): Promise<Backup[]> {
    const url =`${await this.getBackendBaseUrl()}/deployments/${deployment}/backups`
    const params = new URLSearchParams()
    if( namespace !== undefined ) {
      params.set('namespace', namespace)
    }
    if(cluster !== undefined) {
      params.set('cluster', cluster)
    }
    const response = await fetch(`${url}?${params.toString()}`)
    this.throwOnError(response)
    return response.json()
  }

  private async getBackendBaseUrl(): Promise<string> {
    return `${await this.discovery.getBaseUrl('proxy')}/apf`
  }

  private throwOnError(response: Response): void {
    if(response.status >= 300) {
      throw new Error("Request failed with status " + response.status)
    }
  }
}